var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 21V3H21V10H20V4H4.5V20H10.5V21H3.5ZM17.9405 14.5775L19.0835 15.3775C19.3713 15.6266 19.602 15.9348 19.7602 16.281C19.9183 16.6272 20.0001 17.0034 20 17.384V21.1H13V17.3755C13.0002 16.9978 13.081 16.6245 13.2371 16.2805C13.3931 15.9365 13.6209 15.6299 13.905 15.381L13.95 15.3455L15.057 14.577C14.7906 14.3635 14.5754 14.0931 14.4271 13.7856C14.2788 13.4781 14.2012 13.1414 14.2 12.8V12.2C14.2 11.59 14.4423 11.005 14.8737 10.5736C15.305 10.1423 15.89 9.89999 16.5 9.89999C17.11 9.89999 17.695 10.1423 18.1263 10.5736C18.5577 11.005 18.8 11.59 18.8 12.2V12.8C18.7986 13.1417 18.7207 13.4787 18.572 13.7863C18.4233 14.0939 18.2075 14.3643 17.9405 14.5775ZM15.5808 11.2808C15.337 11.5246 15.2 11.8552 15.2 12.2V12.8C15.2 13.1448 15.337 13.4754 15.5808 13.7192C15.8246 13.963 16.1552 14.1 16.5 14.1C16.8448 14.1 17.1754 13.963 17.4192 13.7192C17.663 13.4754 17.8 13.1448 17.8 12.8V12.2C17.8 11.8552 17.663 11.5246 17.4192 11.2808C17.1754 11.037 16.8448 10.9 16.5 10.9C16.1552 10.9 15.8246 11.037 15.5808 11.2808ZM14 17.3755V20.1H19V17.384C19 17.1509 18.9508 16.9205 18.8555 16.7079C18.7602 16.4952 18.621 16.3051 18.447 16.15L16.943 15.1H16.056L14.543 16.15C14.3721 16.3051 14.2355 16.4943 14.142 16.7053C14.0485 16.9164 14.0001 17.1447 14 17.3755Z",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-profile.bab30214d1b88bd258ec8d5edf0c862b.svg";